module.exports = __webpack_public_path__ + "images/mobile/home_banner_bg-efc27729615009f43792d664ac6ced43.jpg";